import { DocumentMode } from '@root/@types/types';

import type { TransitionConfigMap } from '../types';

export const FIRM_ORDER_TRANSITIONS: TransitionConfigMap = {
  DRAFT: {
    [DocumentMode.SUBMISSIONS]: () => ({
      title: 'Return to Draft state?',
      content: 'Setting this contract back to Draft will unlock it for editing.',
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, return to Draft' },
      },
      icon: { type: 'warning' },
    }),
  },
  ARCHIVED: {
    [DocumentMode.SUBMISSIONS]: () => ({
      title: 'Archive contract?',
      content:
        'Setting this contract to Archived will take it out of active use. It must be returned to Draft to make it editable again.',
      buttons: {
        cancel: true,
        confirm: {
          text: 'Yes, archive contract',
        },
      },
      icon: { type: 'warning' },
    }),
  },
  FINAL: {
    [DocumentMode.SUBMISSIONS]: () => ({
      title: 'Ready to finalise contract?',
      content:
        'By setting this contract to Final, it will be locked. Any further changes must be made as endorsements or through a renewal.',
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, finalise contract' },
      },
      icon: { type: 'valid' },
      validation: { required: true },
    }),
  },
  REVIEW: {
    [DocumentMode.SUBMISSIONS]: () => ({
      title: 'Return to Review state?',
      content: 'By setting this contract back to Review, it will become read-only and prepared for review.',
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, return to Review' },
      },
      icon: { type: 'warning' },
    }),
  },
};
